/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Faq_A6Inputs */

const en_sorter_faq_a6 = /** @type {(inputs: Sorter_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keys consisting only of digits are held separately from string keys and always emitted in ascending numeric order, before every other key. Descending mode cannot change that. It is a property of how JavaScript objects store keys, so it affects every browser based JSON tool.`)
};

const ko_sorter_faq_a6 = /** @type {(inputs: Sorter_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숫자만으로 된 키는 문자열 키와 별도로 보관되며 항상 다른 모든 키보다 앞에 오름차순으로 출력됩니다. 내림차순 모드로도 바꿀 수 없습니다. 자바스크립트 객체가 키를 저장하는 방식의 성질이므로, 브라우저 기반 JSON 도구 전체에 영향을 줍니다.`)
};

const ja_sorter_faq_a6 = /** @type {(inputs: Sorter_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字だけのキーは文字列キーとは別に保持され、常にほかのすべてのキーより前に昇順で出力されます。降順モードでも変えられません。JavaScript のオブジェクトがキーを保存する方式の性質なので、ブラウザベースの JSON ツール全体に影響します。`)
};

/**
* | output |
* | --- |
* | "Keys consisting only of digits are held separately from string keys and always emitted in ascending numeric order, before every other key. Descending mode ca..." |
*
* @param {Sorter_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_faq_a6 = /** @type {((inputs?: Sorter_Faq_A6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Faq_A6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_faq_a6(inputs)
	if (locale === "ko") return ko_sorter_faq_a6(inputs)
	return ja_sorter_faq_a6(inputs)
});